module.exports = __webpack_public_path__ + "img/none_bg.f85c09a2.png";